// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__sZjHX","truncatedText":"styles_truncatedText__QUPh6","fullText":"styles_fullText___55b3","textContainer":"styles_textContainer__EB21u"};